/* eslint-disable no-unused-vars */
export interface userModel {
  id: number
  name: string
  role_id: number
}
export interface responseUser {
  access_token: string
  token_type: string
  user: userModel
}
export enum roleType {
  ADMIN = 1,
  USER = 2
}
export interface userInfo {
  key?: number,
  id: number,
  name: number | string
  password: string
  role_id: roleType
  app_magazine_list?: {
    id: number,
    app_name: string
  }[]
  app_magazine_ids?: string[]
  memo?: string,
  public_password?:string
}


export interface reqCreateUser {
  name: string,
  password: string
  role_id: roleType
  magazine_app_ids?: string[]
  memo?: string
}
